import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { debounceTime, distinctUntilChanged, filter, switchMap } from 'rxjs/operators';
import { MilestoneApi } from 'shared/sdk';

@Component({
  selector: 'app-objective-lookup',
  templateUrl: './objective-lookup.component.html',
  styleUrls: ['./objective-lookup.component.css']
})
export class ObjectiveLookupComponent implements OnInit {

  public searchInput = new EventEmitter<string>();

  @Input() set resetData(isClear) {
    if (isClear) {
      this.selectedRecord = null;
    }
  }

  @Input() isMultiSelect = true;
  @Input() placeholder = 'Objective';
  @Output() getEventObj: EventEmitter<any> = new EventEmitter();
  recordList: any;
  itemsPerBatch = 50;
  notFoundText: string;
  orderBy = 'id DESC';
  maxSelectedItems = 1;
  whereFilter: any = {PgMO_Projects__c: 'a6f2L0000004E3lQAE'};
  selectedRecord = null;

  constructor(private _recordsApi: MilestoneApi) { }

  ngOnInit() {
    this.preselectedRecord();
    this.getRecordsList();
    this.getSelectedRecordsList();
  }

  preselectedRecord() {
    const preSelected = localStorage.getItem('filterObj');
    if(!this.selectedRecord) {
      this.selectedRecord = JSON.parse(preSelected)['objective'];
    }
  }

  getSelectedRecordsList() {
    if (this.selectedRecord) {
      this.loadRecordsList().subscribe(
        x => {
          x.map(ele => { ele['Label'] = ele['Form_Name__c'] + ' (' + ele['Objective_Number__c'] + ')' });
          this.recordList = x;
          this.notFoundText = (this.recordList.length === 0) ? 'No objective found.' : '';
        },
        err => {
          this.recordList = [];
        }
      )
    }
  }

  getRecordsList() {
    this.searchInput
      .pipe(
        filter(search => search && search.length > 3),
        debounceTime(200),
        distinctUntilChanged(),
        switchMap(search => this.loadRecordsList(search))
      ).subscribe(
        x => {
          x.map(ele => { ele['Label'] = ele['Form_Name__c'] + ' (' + ele['Objective_Number__c'] + ')' });
          this.recordList = x;
          this.notFoundText = (this.recordList.length === 0) ? 'No objective found.' : '';
        },
        err => {
          console.log(err);
          this.recordList = [];
        }

      );
  }

  loadRecordsList(search?) {
    if (search) {
      const searchPattern = { like: '%' + search.trim() + '%', options: 'i' };
      this.whereFilter['or'] = [{Form_Name__c: searchPattern}, {Objective_Number__c: searchPattern}];
    }
    if (!search && this.selectedRecord) {
      this.whereFilter['sfdcId'] = this.selectedRecord;
    } else if (this.whereFilter['sfdcId']) {
      delete this.whereFilter['sfdcId'];
    }

    const reqObj = {
      'fields': ['Form_Name__c', 'Objective_Number__c', 'sfdcId'],
      'where': this.whereFilter,
      limit: this.itemsPerBatch,
      order: this.orderBy
    };
    return this._recordsApi.find(reqObj);
  }

  clearRecords() {
    this.selectedRecord = null;
    this.notFoundText = 'Type to search objective.';
    this.getEventObj.emit(null);
  }

  onRecordsChange() {
    this.getEventObj.emit(this.selectedRecord);
  }
}
